import { DataGrid } from "@mui/x-data-grid";
import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import {
  Breadcrumbs,
  Grid2,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import * as services from "./../../services/saleng";
import AppBreadcrumbs from "./../../components/AppBreadcrumbs";

function formatNumber(number) {
  return number.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}

const Transaction = () => {
  const [rows, setRows] = useState([]);
  const { transactionId } = useParams();
  const [data, setData] = useState();
  const columns = [
    {
      field: "productName",
      headerName: "สินค้า",
      flex: 2,
    },
    {
      field: "weight",
      headerName: "น้ำหนัก",
      type: "number",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {formatNumber(params.row.weight)}
            <span style={{ color: "gray" }}>{" กิโล"}</span>
          </>
        );
      },
    },
    {
      field: "pricePerUnit",
      headerName: "ราคาต่อน้ำหนัก",
      type: "number",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {formatNumber(params.row.pricePerUnit)}
            <span style={{ color: "gray" }}>{" บาท"}</span>
          </>
        );
      },
    },
    {
      field: "total",
      headerName: "รวม",
      type: "number",
      flex: 1,
      renderCell: (params) => {
        return (
          <>
            {formatNumber(params.row.total)}
            <span style={{ color: "gray" }}>{" บาท"}</span>
          </>
        );
      },
    },
  ];

  useEffect(() => {
    const fetchData = async () => {
      services
        .getTransaction(transactionId)
        .then((response) => {
          console.log("response : ", response);
          const transaction = response.data.data;

          // แปลง ISO datetime เป็น Date object
          const date = new Date(transaction.createdAt);

          // คำนวณเวลาตาม Timezone ของเครื่อง
          const localDate = new Date(
            date.getTime() - date.getTimezoneOffset() * 60000
          );

          // แปลงเป็นรูปแบบ YYYY-MM-DD HH:mm:ss
          const formattedDate = localDate
            .toISOString()
            .replace("T", " ")
            .split(".")[0];

          const sortData = {
            ...transaction,
            TransactionId: transaction.transactionId,
            date: formattedDate, // วันที่ + เวลาเครื่อง
            branchName: transaction.branch.name,
            customerName: transaction.customerName,
            totalWeight: formatNumber(transaction.totalWeight),
            totalAmount: formatNumber(transaction.totalAmount),
            description: "",
          };

          console.log("sortData : ", sortData);
          setData(sortData);
          setRows(sortData?.items);
        })
        .catch((error) => {
          console.log("error : ", error);
        });
    };

    fetchData();
  }, [transactionId]);

  return (
    <div>
      <AppBreadcrumbs />

      <Typography component="h2" variant="h5" my={2}>
        รายละเอียดคำสั่งซื้อ
      </Typography>

      <p
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 10,
        }}
      >
        ข้อมูลรายการ
      </p>
      <Grid2 container spacing={2}>
        <Grid2 size={6}>
          <TextField
            id="standard-basic"
            label="เลขบิล"
            variant="standard"
            value={data?.billNumber || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="วันที่"
            variant="standard"
            value={data?.date || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="สาขา"
            variant="standard"
            value={data?.branchName || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={3}>
          <TextField
            id="standard-basic"
            label="ชื่อลูกค้า"
            variant="standard"
            value={data?.customerName || ""}
            fullWidth
          />
        </Grid2>
        <Grid2 size={2}>
          <TextField
            id="standard-basic"
            label="น้ำหนักสุทธิ"
            variant="standard"
            value={data?.totalWeight || ""}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">กิโล</InputAdornment>
                ),
              },
            }}
            fullWidth
          />
        </Grid2>
        <Grid2 size={2}>
          <TextField
            id="standard-basic"
            label="ราคาสุทธิ"
            variant="standard"
            value={data?.totalAmount || ""}
            slotProps={{
              input: {
                endAdornment: (
                  <InputAdornment position="end">บาท</InputAdornment>
                ),
              },
            }}
            fullWidth
          />
        </Grid2>
      </Grid2>

      <br />
      <br />
      <p
        style={{
          display: "flex",
          justifyContent: "center",
          margin: 10,
        }}
      >
        รายละเอียดสินค้า
      </p>
      <DataGrid
        rows={rows}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
        }}
        pageSizeOptions={[5]}
        disableRowSelectionOnClick
      />
    </div>
  );
};

export default Transaction;
